<app-relatorio-container
    tituloRelatorio="Certidão de Cancelamento"
    descricaoRelatorio="Certidão de cancelamento da inscrição do prestador"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'certidao-cancelamento-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm text-color-secondary m-0">A certidão é emitida para o prestador selecionado, desde que esteja com situação cadastral "Cancelado" e possua histórico de responsável técnico. Nenhum filtro adicional é necessário.</p>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Certidão" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
